import React, { FC, useCallback, useEffect, useMemo, useState } from "react";
import VerificationCodeInput from "@/components/Input/verifyCodeInput";
import { phoneNumberVerification } from "../AccountLogin/utils/verification";
import { Toast } from "@/components/Toast";
import { getPhoneVCode } from "../../api";
import LoginStore, { loginStore } from "@/modules/login/store";
import { observer } from "mobx-react-lite";
import { Input, Button, Text, Stack, Flex } from "@chakra-ui/react";
import { withRouter, RouteComponentProps } from "react-router";
import { langStore, translate } from "@noli/business";
import { themeStore } from "@/stores/theme";
import { Login_Words, Toast_Words } from "@/utils/lang";

interface BindPhoneProps {
  loginStore?: LoginStore;
}

const BindPhone: FC<BindPhoneProps & RouteComponentProps> = ({ history }) => {
  const { phone, visible } = loginStore.loginState;
  const { loginBtnColor } = themeStore.styles;
  const [vCode, setVCode] = useState("");
  const [loading, setLoading] = useState(false);

  const [prevGetVCodeTimestamp] = useState<string | null>(
    localStorage.getItem("prevBindGetVCodeTimestamp"),
  );
  const lang = langStore.tgt;
  const getVerifyTranslate = useCallback(
    (time: number) => {
      return time > 0
        ? translate(Login_Words.codeDisable, lang).replace("$", String(time))
        : translate(Login_Words.getCode, lang);
    },
    [lang],
  );

  useEffect(() => {
    if (visible) setVCode("");
  }, [visible]);

  const phoneVerification = useMemo((): boolean => phoneNumberVerification(phone), [phone]);

  const vCodeVerification = useMemo((): boolean => {
    const reg = /^[0-9]\d{5}$/;
    return reg.test(vCode);
  }, [vCode]);

  const loginEnable = useMemo(
    () => phoneVerification && vCodeVerification,
    [phoneVerification, vCodeVerification],
  );

  const setPhone = (value: string) => {
    loginStore?.setPhone(value);
  };

  const handlerGetVCode = useCallback(() => {
    if (phoneVerification) {
      localStorage.setItem("prevBindGetVCodeTimestamp", `${new Date().getTime()}`);

      getPhoneVCode({
        mobileNumber: phone,
      }).catch((err) => {
        Toast({
          title: translate(Toast_Words.codeSendFail, lang),
          status: "error",
        });
      });
    } else Toast({ title: translate(Toast_Words.accountInvalid, lang), status: "warning" });

    return phoneVerification;
  }, [phoneVerification, phone, lang]);

  const handlerLogin = () => {
    setLoading(true);
    loginStore
      ?.loginByWeChatWithPhone(vCode)
      .then((res) => {
        if (res.errCode == 0) {
          Toast({
            title: translate(Toast_Words.loginSuccess, lang),
            status: "success",
          });
          loginStore?.closeLoginDialog();
          loginStore.resetDialogType();
          history.push("/creator");
        } else {
          Toast({
            title: translate(Toast_Words.loginFailed, lang),
            status: "error",
          });
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Flex w="100%" justifyContent="center" flexDir="column" paddingX="10px">
      <Text mt="16px" mb="8px" fontSize="14px" color={"#4E5969"}>
        手机号
      </Text>
      <Input
        color="inherit"
        _focusVisible={{ borderColor: loginBtnColor }}
        _placeholder={{ color: "#C9CDD4", fontSize: "14px" }}
        borderColor="fill.emphasis"
        value={phone}
        onChange={(e) => setPhone(e.target.value)}
        placeholder="请输入手机号"
      />
      <Text mt="16px" mb="8px" fontSize="14px" color={"#4E5969"}>
        验证码
      </Text>
      <VerificationCodeInput
        value={vCode}
        btnText={getVerifyTranslate}
        onChange={(e) => {
          const target = e.target as HTMLInputElement;
          setVCode(target.value);
        }}
        length={6}
        placeholder="请输入验证码"
        onGetCode={handlerGetVCode}
        prevGetCodeTimestamp={prevGetVCodeTimestamp}
        flex="0 0 auto"
      />
      <Button
        type="button"
        size="md"
        bgColor="#36c19e"
        _hover={{
          bgColor: "#36c19e",
        }}
        rounded="full"
        mt="80px"
        _active={{}}
        color="#fff"
        disabled={!loginEnable}
        onClick={handlerLogin}
        isLoading={loading}
        style={{ height: "40px" }}
      >
        绑定
      </Button>
    </Flex>
  );
};

export default withRouter(observer(BindPhone));
